import React from 'react'

export type UseCanonicalProps = {
  enabled: boolean;
  url?: string;
}

export function useCanonical({ enabled, url }: UseCanonicalProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      <link rel='canonical' href={url} />
    </>
  )
}